import { ComparisonItem } from "@/types/comparison";
import { imageDimensions } from "./imageDimensions";
import { autoIcon, bundleIcon, clockIcon } from "./gcsImagePaths";
import { computerIcon, customizationIcon, homeIcon } from "./gcsImagePaths";
import { specialtyIcon, underline } from "./gcsImagePaths";

export const captiveComparisons: ComparisonItem[] = [
  { guardian: "Warm Inbound Leads", competitor: "Cold Calling" },
  {
    guardian: "Salaried + Bonus Compensation",
    competitor: "Commission-Driven Sales",
  },
  {
    guardian: "50+ Top-Rated Carriers",
    competitor: "One Carrier, Limited Options",
  },
  { guardian: "Modern Tools & Marketing", competitor: "Old School Tactics" },
  { guardian: "Leaders Who Work for Agents", competitor: "Top-Down Hierarchy" },
  {
    guardian: "Continuous Reshopping",
    competitor: "Customers Frustrated With Price Hikes You Can't Control",
  },
];

export const insurtechComparisons: ComparisonItem[] = [
  {
    guardian: "Financially Stable",
    competitor: "Risk of Instability or Collapse",
  },
  {
    guardian: "Backed by Experienced Operators",
    competitor: "Dependent on Venture Funding or Market Sentiment",
  },
  {
    guardian: "Proven Tools & Technology",
    competitor: "DIY Systems & Constant Beta Testing",
  },
  { guardian: "Long-Term Career Growth", competitor: "Uncertain Futures" },
  {
    guardian: "Built to Scale Responsibly",
    competitor: "Focused on Rapid Scale",
  },
];

export const underlineDim = imageDimensions[underline];
export const bundleIconDim = imageDimensions[bundleIcon];
export const homeIconDim = imageDimensions[homeIcon];
export const autoIconDim = imageDimensions[autoIcon];
export const specialtyIconDim = imageDimensions[specialtyIcon];
export const computerIconDim = imageDimensions[computerIcon];
export const clockIconDim = imageDimensions[clockIcon];
export const customizationIconDim = imageDimensions[customizationIcon];
